(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    

  //
  
/*var slideshow_slider = $('.slideshow__items' ).slick( {
    fade: true,
    dots: true,
    arrows: false,
    autoplaySpeed: $('.slideshow' ).data('autoplay-speed'),
    autoplay: false,
    
    appendDots: '.slideshow__nav-wrapper'
} );
document.addEventListener("shopify:section:load", function(event) {
  slideshow_slider = $('.slideshow__items' ).slick( {
        fade: true,
        dots: true,
        arrows: false,
        autoplay: false,
        autoplaySpeed: $('.slideshow' ).data('autoplay-speed'),
        appendDots: '.slideshow__nav-wrapper'
    } );
});

document.addEventListener("shopify:block:select", function(blockId,sectionId,load) { 
    if($(blockId.explicitOriginalTarget).hasClass('slideshow__slide')){ 
        slideshow_slider.slick('slickPause');
        slideshow_slider.slick('slickGoTo', $(blockId.explicitOriginalTarget).data('slick-index'));  
    } 
});
document.addEventListener("shopify:block:deselect", function(blockId,sectionId) { 
    if($(blockId.explicitOriginalTarget).hasClass('slideshow__slide')){ 
        slideshow_slider.slick('slickPlay');
    } 
});*/



  } catch(e) { console.error(e); }
})();
})();
